import { GET_BANNER_SETTINGS, GET_BASIC_SETTINGS, GET_DASHBOARD_DATA } from "store/actions/app";

const initialState = {
  dashboard: {},
  basicSettings: {},
  bannerSettings: null,
};

//get 
const getDashboardData = (state, payload) => {
  const { data, callback } = payload;
  if (typeof callback === 'function') {
      callback(payload);
  }
  
  const stateObj = {
      ...state,
      dashboard: data.body,
      loading: false,
  };
  return stateObj;
};

// set basic settings state
const getBasicSettings = (state, payload) => {
  const { data, callback } = payload;
  const stateObj = {
    ...state,
    basicSettings: data?.body,
  };
  return stateObj;
}

// set banner settings state
const getBannerSettings = (state, payload) => {
  const { data, callback } = payload;
  const stateObj = {
    ...state,
    bannerSettings: data?.body,
  };
  return stateObj;
}

const App = (state = initialState, { type, payload = null }) => {
    switch (type) {
        case GET_DASHBOARD_DATA:
          return getDashboardData(state, payload);
        
        case GET_BASIC_SETTINGS:
          return getBasicSettings(state, payload);
        
        case GET_BANNER_SETTINGS:
          return getBannerSettings(state, payload);

        default:
        return state;
    };
}
export default App;